import apiConfig from '../../../apiConfig';
import { getCustomerAuthHeaders } from '../../auth/customerAuthToken';

export type CreateReservationByStaffServiceItem = {
  service_id: number;
};

export type PostCreateReservationByStaffPayload = {
  storeId: number;
  customerId?: number | null;
  customerName?: string | null;
  date: string;
  staffId: number;
  startTime: string;
  services: CreateReservationByStaffServiceItem[];
};

export type PostCreateReservationByStaffResponse = {
  message: string;
  reservation_id: number;
};

export const postCreateReservationByStaff = async (
  payload: PostCreateReservationByStaffPayload,
): Promise<PostCreateReservationByStaffResponse> => {
  const res = await fetch(`${apiConfig.baseURL}/api/customer-app/reservation/by-staff/create`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...getCustomerAuthHeaders(),
    },
    body: JSON.stringify({
      store_id: payload.storeId,
      customer_id: payload.customerId ?? null,
      customer_name: payload.customerName ?? null,
      date: payload.date,
      staff_id: payload.staffId,
      start_time: payload.startTime,
      services: payload.services,
    }),
  });

  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data?.error || 'Failed to create reservation');
  }

  return (await res.json()) as PostCreateReservationByStaffResponse;
};
